import React from 'react';
import PropTypes from 'prop-types';
import { getValidationFeedbackClass } from 'utils/formValidations';
import inputStyles from '../purchase/CieloTDCForm/inputStyles';

/**
 * Simple WebView version of CieloTDCFormInput without @reservamos/elements dependencies
 */
const CieloWebViewFormInput = ({
  id,
  name,
  className = '',
  value = '',
  disabled = false,
  onBlur = () => {},
  onChange = () => {},
  label = '',
  isValid = false,
  hasError = false,
}) => {
  return (
    <div className="w-full">
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          marginBottom: '8px',
          color: '#1f2937',
        }}
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        className={`${className} ${inputStyles} ${getValidationFeedbackClass(isValid, hasError)}`}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '12px 16px',
          fontSize: '16px',
        }}
      />
    </div>
  );
};

CieloWebViewFormInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.string,
  isValid: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default CieloWebViewFormInput;
